module.exports = __webpack_public_path__ + "img/chess_chinesechessblack1.850089ba.png";